import { render, staticRenderFns } from "./FadeAnimation.vue?vue&type=template&id=484a45d8&scoped=true&"
import script from "./FadeAnimation.vue?vue&type=script&lang=js&"
export * from "./FadeAnimation.vue?vue&type=script&lang=js&"
import style0 from "./FadeAnimation.vue?vue&type=style&index=0&id=484a45d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a45d8",
  null
  
)

export default component.exports